import * as v from 'valibot';
import { fieldModelErrors as fErr, txtIsRequired } from '~/constants';

export const EmailModel = v.pipe(
    v.string(fErr.email),
    v.email(`Valid email ${txtIsRequired}`)
);
